import { TranslationKey } from './../../../../../types/translation/TranslationKey';
import React, { useContext } from 'react';
import { t } from '../../../../../types/translation/Translator';
import { OrderContext } from '../../../../../context/OrderContext';
import DeleteModal from '../../../../../VentoryUI/components/common/Modal/DeleteModal';
import { OrderInput } from '../../../../../types/order/';
import { useRequest } from '../../../../../requests/common/requestHook';
import { OrderRequest } from '../../../../../requests/order.request';

interface DeleteOrderModalProps {
  open: boolean;
  onClose: () => void;
  ids: Set<string>;
  setSelected: (selected: Set<string>) => void;
}

export default function DeleteOrderModal({ open, onClose, ids, setSelected }: DeleteOrderModalProps) {
  const { orders, setOrders } = useContext(OrderContext);

  const [remove, { loading }] = useRequest(OrderRequest.remove);

  const handleDelete = async () => {
    const deletedOrders: OrderInput[] = [];
    for (const id of ids) {
      const order = orders.get(id);
      if (order) deletedOrders.push(new OrderInput(order).forDelete());
    }

    const result = await remove({ data: deletedOrders });
    if (!result) return;

    const items = result;
    for (const order of items) {
      orders.delete(order.id);
    }

    setOrders(new Map(orders));
    onClose();
  };

  return (
    <DeleteModal
      open={open}
      loading={loading}
      onClose={onClose}
      onConfirm={handleDelete}
      text={t(TranslationKey.verifyDeleteOrders).singular.upper}
    />
  );
}
